import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TwilioSimStatusSelectPage } from './twilio-sim-status-select.page';

const routes: Routes = [
  {
    path: '',
    component: TwilioSimStatusSelectPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TwilioSimStatusSelectPageRoutingModule {}
